import { dateRangeFilter, formatlocaltoTimezone } from "utils/utils";
import { BASELINE_TABLE_STRINGS } from "constants/constantStrings";

import BaselineCloneRenderer from "./BaselineCloneRenderer";

const getFormattedDate = params => {
  if (params) {
    if (params.data.Date) {
      const date = formatlocaltoTimezone(params.data.Date, params.data.Timezone);
      return ` ${date}  ${params.data.Timezone}`;
    }
  }
};
const getFormattedMode = params => {
  if (params) {
    if (params.data.Type) {
      let mode;
      if (params.data.Type === BASELINE_TABLE_STRINGS.auto) {
        mode = BASELINE_TABLE_STRINGS.automated;
      } else if (params.data.Type === BASELINE_TABLE_STRINGS.default) {
        mode = BASELINE_TABLE_STRINGS.defaultText;
      } else {
        mode = BASELINE_TABLE_STRINGS.manual;
      }
      return mode;
    }
  }
};

const getBaselineTableCols = showTableFilterIcon => [
  {
    field: "Id",
    headerName: BASELINE_TABLE_STRINGS.baselineID,
    flex: 1,
    editable: false,
    minWidth: 200,
    defaultSort: "desc",
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => +valueA - +valueB,
    filter: showTableFilterIcon
  },
  {
    field: "Name",
    headerName: BASELINE_TABLE_STRINGS.baselineTitle,
    flex: 2,
    editable: false,
    minWidth: 200,
    filter: showTableFilterIcon
  },
  {
    field: "Type",
    headerName: BASELINE_TABLE_STRINGS.baselineMode,
    valueFormatter: getFormattedMode,
    flex: 2,
    editable: false,
    minWidth: 200,
    filter: showTableFilterIcon
  },
  {
    field: "Date",
    headerName: BASELINE_TABLE_STRINGS.baselineTimestamp,
    valueFormatter: getFormattedDate,
    flex: 1,
    editable: false,
    filter: "agDateColumnFilter",
    filterParams: dateRangeFilter
  },
  {
    colId: "clone",
    lockPinned: true,
    pinned: "right",
    width: 50,
    cellRendererFramework: BaselineCloneRenderer
  }
  // SMRT-1617 hidding button(delete validation to be implemented)
  // ,{
  //   colId: 'delete',
  //   lockPinned: true,
  //   pinned: 'right',
  //   width: 50,
  //   cellRendererFramework: BaselineDeleteRenderer
  // }
];

export default getBaselineTableCols;
